<template>
  <UiModal
    :show="showPresent"
    title="赠送礼物"
      iconType="icon_rule_event"
      :decorate="false"
      bottom-bg
      @clickTitle="handleClickShowTip"
      @close="close"
    >
      <template #header-right>
        <div class="present-herder">
          余额<i class="match"></i
          >{{
            amount.quizRemainNum > 999999
              ? '999999'
              : amount.quizRemainNum
          }}
          <i class="coins"></i>{{ amount.matchRemainNum }}
        </div>
      </template>
      <div class="present">
        <div class="left-box">
            <div class="icon">
              <div
                class="head"
                :style="{ 'background-image': `url(${team.avatar})` }"
              ></div>
              <div class="frame"></div>
            </div>
            <div class="name">
              <UiLabel shadow-color="#fff" text-color="#751818">{{ team.name }}</UiLabel>
            </div>
          </div>
          <div class="right-box" v-if="filteredPresentList.length">
            <div
              v-for="(item, index) in filteredPresentList"
              :key="index"
              :class="['souvenirs', { active: index === selectedSouvenirIndex }]"
              @click="handleClick(item, index)"
            >
              <div class="bg">
                <div class="default"></div>
                <div class="active"></div>
              </div>
              <div class="product" :style="{ backgroundImage: `url(${item.url})` }"></div>
              <div class="tips">
                <i></i>
                <UiLabel>人气值+{{ item.popularity }}</UiLabel>
                <i></i>
                <!-- {{
                  characterSum >= 10000
                    ? (characterSum / 10000).toFixed(2) + '万'
                    : characterSum
                }} -->
              </div>
              <div v-if="index === 0" class="coins">
                <i :style="{ 'background-image': `url(${COIN_ICON})` }"></i>
                <UiLabel shadow-color="#fff" text-color="#333">100</UiLabel>
              </div>
              <div v-else class="coins">
                <UiLabel shadow-color="#fff" text-color="#333">拥有: {{ item.count }}</UiLabel>
              </div>
            </div>
          </div>
        <!-- <div>{{ this.filteredPresentList[0] }}</div> -->
      </div>
      <div class="bottom">
        <div class="left-box">
          <div class="consume" v-if="selectedTab === 'give'">
            <UiLabel>消耗</UiLabel>
            <i :style="{ 'background-image': `url(${selectedSouvenirIndex === 0 ? COIN_ICON : filteredPresentList[selectedSouvenirIndex]?.url})` }"></i>
            <UiLabel>{{ giftID === 'xc003' ? 100 * consumeSum : consumeSum }}</UiLabel>
          </div>
          <div class="consume" v-else></div>
          <div class="character">
            <UiLabel>人气值+<span>{{ characterSum }}</span></UiLabel>
          </div>
        </div>
        <div class="right-box">
          <div class="amount-surplus">
            <i class="del" @click="decreaseValue"></i>
            <div class="counts">
              <UiLabel>{{ initalValue }}</UiLabel>
            </div>
            <i class="add" @click="increaseValue"></i>
          </div>
          <UiButton class="betting-btn" colorType="red" @click="handleClickGive">
            <div class="label-box">
              <span class="label-shadow">赠礼</span>
              <span class="label-text">赠礼</span>
            </div>
          </UiButton>
        </div>
      </div>
      <!-- 点击提醒 tip -->
      <transition name="fade">
        <div v-if="showPoptip" class="poptip">
          <div class="poptip-content">
            <span>
              赠送礼物可以给战队增加人气值，同时个人可以获得贡献值，战队人气值等于个人贡献值
            </span>
          </div>
        </div>
      </transition>
  </UiModal>
  <UiModalConfirm iconType="tip_2" ref="confirmed" :options="confirmOptions" @apply="Confirmationofgift" />
</template>

<script setup>
import { ref, computed, watch, useTemplateRef } from 'vue'
import { useAppStore } from '@/store'
import { useModal } from '@/composables/useModal'
import * as api from '@/service'
import { usePrompt } from '@/composables/usePrompt'
import UiModal from '@/components/ui-modal.vue'
import UiButton from '@/components/ui-button.vue'
import UiLabel from '@/components/ui-label.vue'
import UiModalConfirm from '@/components/ui-modal-confirm.vue'

const appStore = useAppStore()
const { showPrompt } = usePrompt()

const confirmed = useTemplateRef('confirmed')

// 控制弹框
const showPresent = ref(false)
// 战队信息
const team = ref({})
// 背景颜色控制
const selectedSouvenirIndex = ref(0)
// 控制tip
const showPoptip = ref(false)
// 状态锁
// 初始值
const initalValue = ref(0)
const consume = ref(0)
const consumeSum = ref(0)
const character = ref(0)
const characterSum = ref(0)
const teamCode = ref(0)
const giftID = ref(0)
const selectedTab = ref('give')
const cachedPresentList = ref([])
const presentList = ref([])
const count = ref(1)
// 竞猜币 icon, 首项礼物 (xc003 竞猜币兑换) 用它做视觉标识
const COIN_ICON = 'https://website.xdcdn.net/module/sausage-match/images/quiz/coin.png'
const confirmOptions = ref({
  tip: '您确定要赠送该礼物么？',
  cancel: { label: '返回', colorType: 'gold' },
  apply: { label: '确认', colorType: 'red' }
})

const amount = computed(() => appStore.amount)
const token = computed(() => appStore.token)

// 设置初始值
// 赠礼

const filteredPresentList = computed(() => {
  // return selectedTab.value === 'back'
  //   ? cachedPresentList.value
  //   : presentList.value
  return presentList.value
})

watch(initalValue, () => {
  // 监听 initalValue 变化，更新消耗和人气值
  updateValues()
})
watch(selectedTab, (newValue) => {
  // console.log('newValue',newValue)
  // console.log('newValue')
  if (newValue === 'back') {
    // 当切换到 'back' 选项卡并且缓存的数据为空时，才请求接口获取数据
    fetchPresentList()
  } else {
    const defaultInitData = presentList.value[0]
    const { coins, popularity, giftId } = defaultInitData
    selectedSouvenirIndex.value = 0
    consume.value = coins
    character.value = popularity
    initalValue.value = 1
    consumeSum.value = coins
    characterSum.value = popularity
    giftID.value = giftId
  }
})

// 接入 modal store: openModal({id: 'present', params: {team, presentList}}) 触发
// 双阶段模式保留 (先空 params 打开占位, 拉完礼物再填 params 刷新内容)
const { close } = useModal('present', showPresent, {
  onOpen(params) {
    const teamData = params?.team
    const listData = params?.presentList
    team.value = teamData
    presentList.value = listData
    if (!teamData || !listData) return
    // 默认第一个
    const defaultInitData = listData[0]
    const { popularity, giftId } = defaultInitData
    selectedSouvenirIndex.value = 0
    character.value = popularity
    initalValue.value = 0
    characterSum.value = popularity
    giftID.value = giftId
    count.value = listData[0].count
    teamCode.value = teamData.teamCode
    selectedTab.value = 'give'
  }
})

// 选中
function handleClick(item, index) {
  if (selectedSouvenirIndex.value === index) {
    return
  } else {
    // 当前的商品信息
    // console.log('item',item)
    const { popularity = 0 } = item
    consume.value = 0
    character.value = popularity
    initalValue.value = 0
    count.value = item.count
    giftID.value = item.giftId
    selectedSouvenirIndex.value = index
    updateValues()
  }
}

function updateValues() {
  consumeSum.value = initalValue.value
  characterSum.value = character.value * initalValue.value
}
function increaseValue() {
  if (initalValue.value < count.value && count.value !== 0) {
    initalValue.value++
    updateValues()
  } else {
    const message =
      selectedSouvenirIndex.value === 0
        ? '货币数量不足，请重新选择'
        : '礼物数量不足，请重新选择'
    showPrompt(message, 800)
  }
}
function decreaseValue() {
  if (count.value === 0) {
    const message =
      selectedSouvenirIndex.value === 0
        ? '货币数量不足，请重新选择'
        : '礼物数量不足，请重新选择'
    showPrompt(message, 800)
    return
  }
  if (count.value >= initalValue.value && initalValue.value > 0) {
    initalValue.value--
    updateValues()
  } else {
    showPrompt('请选择礼物进行赠送', 800)
  }
}

// 每次点击都重置 timer, 从最后一次点击起算 1200ms 关闭 (连点也不会提前消失)
let poptipHideTimer = null
function handleClickShowTip() {
  showPoptip.value = true
  clearTimeout(poptipHideTimer)
  poptipHideTimer = setTimeout(() => {
    showPoptip.value = false
  }, 1200)
}

async function handleClickGive() {
  // 如果是第一个礼物，就判断赛事币，否则就是存量

  // 判断存量了
  const quite = count.value !== 0 && count.value >= initalValue.value
  if (quite) {
    if(initalValue.value >= 1) {
      confirmed.value.showModal()
    } else {
      showPrompt('请选择赠送的礼物数量', 1200)
    }
  } else {
    showPrompt('礼物不足,参与活动可以获得礼物', 1200)
  }
}
// 确认赠送
async function Confirmationofgift() {
  try {
    let data = {
      giftId: giftID.value,
      count: initalValue.value,
      teamCode: teamCode.value,
      force: true
    }
    if(!token.value) return;
    const res = await api.directPresentGift(token.value, data)
    // console.log('res', res)
    if (res.status === 200) {
      // console.log('强刷商品列表,',this.selectedSouvenirIndex)
      if (selectedSouvenirIndex.value === 0) {
        // 扣除 赛事币
        appStore.reqUserInfo(true)

        if (typeof tapdb === 'undefined') return
        // 当前消耗的竞猜币
        tapdb.trackEvent('赠送比心', {
          '#value_change': initalValue.value * 100,
          '#value_after': amount.value.quizRemainNum,
          '#coin_id': 'xc001',
          '#via_type': '比心由竞猜币兑换获得',
          '#team_id': teamCode.value,
          '#value_hot': characterSum.value
        })
      } else {
        // 强刷商品列表
        if(!token.value) return;
        const res = await api.reqGiftList({
          token: token.value,
          force: true
        })
        if (res.status === 200) {
          // TODO 数据接口稳定后恢复赠礼后道具余量埋点
        }
      }
      showPrompt('赠送成功', 1000)
      setTimeout(close, 1000)
    } else {
      showPrompt('赠送失败,请稍后尝试', 800)
    }
  } catch (err) {
    console.log('err', err)
  }
}

async function fetchPresentList() {
  try {
    // 请求接口获取数据
    if(!token.value) return;
    const req = await api.reqGiftList({ token: token.value })
    if (req.status === 200) {
      // console.log('res', req)
      cachedPresentList.value = req.data

      const defaultInitData = cachedPresentList.value[0]
      if (defaultInitData) {
        const { coins, popularity, giftId } = defaultInitData
        selectedSouvenirIndex.value = 0
        consume.value = coins
        character.value = popularity
        initalValue.value = 1
        consumeSum.value = coins
        characterSum.value = popularity
        giftID.value = giftId
      }
    }
  } catch (error) {
    console.error(error)
  }
}
</script>

<style lang="scss" scoped>
@import 'present';
</style>
